<h3 mat-dialog-title>
  {{ alertLabel }}
</h3>

<mat-dialog-actions align="end">
  <button mat-flat-button mat-dialog-close>Cancel</button>
  <button *ngIf="data" mat-flat-button color="primary" (click)="onSend()">
    Save
  </button>
  <button *ngIf="!data" mat-flat-button color="primary" (click)="onSend()">
    Submit
  </button>
</mat-dialog-actions>
